import React from 'react';
import { X, Trash2 } from 'lucide-react';
import { DialogBackdrop } from '../../../components/ui/dialog-backdrop';
import styles from './EditAutomationTemplate.module.css';

const { deleteConfirmDialog, deleteConfirmDialogContent } = styles;

interface DeleteActionConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  actionTitle: string;
}

export const DeleteActionConfirmDialog: React.FC<DeleteActionConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
  actionTitle,
}) => {
  if (!open) return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <>
      <DialogBackdrop onClose={onClose} />
      <dialog className={deleteConfirmDialog} open>
        <div className={deleteConfirmDialogContent}>
          <header>
            <h2>Delete Action</h2>
            <button onClick={onClose} type="button" aria-label="Close">
              <X />
            </button>
          </header>
          <main>
            <p>
              Are you sure you want to delete the <strong>{actionTitle}</strong> action? This action
              cannot be undone.
            </p>
          </main>
          <footer>
            <button type="button" onClick={onClose}>
              Cancel
            </button>
            <button type="button" onClick={handleConfirm} data-variant="destructive">
              <Trash2 />
              Delete
            </button>
          </footer>
        </div>
      </dialog>
    </>
  );
};
